import { Masterdata, MasterdataAService } from "../../../services/index";

interface IResolve {
    salaryScales: Masterdata[];
}

class SalaryScalesDialogController {

    private resolve: IResolve;
    private salaryScale: Masterdata;

    constructor(
        private MasterdataAService: MasterdataAService,
        private $state: ng.ui.IStateService,
        private $stateParams: ng.ui.IStateParamsService,
    ) {
        'ngInject';
    }

    public $onInit = () => {
        let salaryScaleId = this.$stateParams['id'];
        if (salaryScaleId) {
            this.salaryScale = this.resolve.salaryScales.find(s => s.id === salaryScaleId);
        } else {
            this.salaryScale = new Masterdata();
            this.salaryScale.type = 'WageCodes';
        }
    }

    submitSalaryScale() {
        if (this.salaryScale.id === undefined) {
            this.MasterdataAService.customPost('WageCodes', this.salaryScale).then((result: any) => {
                this.$state.go('^', { }, {reload: true});
            });
        } else {
            this.MasterdataAService.put(this.salaryScale.id, this.salaryScale).then(result => {
                this.$state.go('^', { }, {reload: true});
            });
        }
    }

    delete() {
        this.MasterdataAService.delete(this.salaryScale.id).then((result: any) => {
            this.$state.go('^', { }, {reload: true});
        });
    }
}

export const salaryScalesDialogComponent = { 
    bindings: {
        resolve : "<",
        close: "&"
    },
    controller: SalaryScalesDialogController,
    template: require('./salaryScale.dialog.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/settings/salaryScales/salaryScale.dialog.component.ts